import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const Conversations = () => {
  return (
    <Box>
      <Grid
        container
        spacing={{ xs: 1, lg: 8 }}
        sx={{
          justifyContent: 'center',
          py: { lg: 20, xs: 8 },
        }}
      >
        <Grid
          size={{ xs: 12, lg: 1 }}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center' },
            alignSelf: 'start',
          }}
        >
          <img alt="" src="/landing/chat-bubble.svg" />
        </Grid>
        <Grid>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontWeight: 'medium',
              fontSize: { lg: '50px', xs: '35px' },
              lineHeight: '50px',
              textAlign: 'center',
            }}
          >
            <span style={{ color: '#2C5889' }}>Conversaciones</span>
            <br />
            humanas
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Jost',
              fontWeight: 'regular',
              fontSize: { lg: '22px', xs: '18px' },
              lineHeight: '25px',
              pt: { lg: 4, xs: 2 },
            }}
          >
            Usamos AI para hablar como humanos, <br />
            pero con las ventajas de ser un robot.
          </Typography>
        </Grid>
        <Grid
          sx={{
            alignSelf: 'end',
            display: { xs: 'none', lg: 'block' },
          }}
        >
          <img alt="" src="/landing/chat-bubble.svg" style={{ width: '100%' }} />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={8}
        sx={{
          justifyContent: 'center',
          pb: 8,
        }}
      >
        <Grid>
          <img alt="" src="/landing/conversation24-7.svg" style={{ width: '100%' }} />
        </Grid>
        <Grid>
          <img alt="" src="/landing/conversation-personal.svg" style={{ width: '100%' }} />
        </Grid>
        <Grid>
          <img alt="" src="/landing/conversation-auto.svg" style={{ width: '100%' }} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Conversations;
